import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useStyles } from "../../common/appStyles";
import { ThemeProvider, createTheme } from '@mui/material';

/**
 * @param props - allows user to click yes or no in order to confirm their Changes.
 * @returns - a Dialog with text and two buttons on it (yes and no).
 * @remarks The Confirm box is for allowing a user to make sure they are updating their info correctly.
 */
export function ConfirmProfile(props) {
    const { submit, close, showConfirm } = props;
    const classes = useStyles();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#10AD61'
            },
            secondary: {
                main: '#10AD61'
            },
            background: {
                default: '#ffffff'
            },
        },
        typography: {
            h6: {
                color: '#484A57'
            },
            h4: {
                color: '#484A57'
            },
            body1: {
                color: 'black'
            }
        },
    });

    const handleConfirm = () => {
        submit();
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Dialog
                    open={showConfirm}
                    onClose={close}
                    fullWidth
                    maxWidth={'xs'}
                >
                    <Grid container alignItems={"center"} justifyContent={'center'}>
                        <Grid item>
                            <Grid
                                container
                                className={classes.subWrapper4}
                                direction={"column"}
                                justifyContent={'center'}
                                alignItems={"center"}
                                rowSpacing={2}
                            >
                                <Grid item xl={12}>
                                    <Grid container direction={'column'} className={classes.gridPadding} >
                                        <Grid item>
                                            <Typography align='center' variant='h5'>
                                                Are you sure you want to update your profile?
                                            </Typography>
                                            <Typography variant='body1' align='center'>
                                                Please make sure you have properly entered all fields to be updated.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xl={12}>
                                    <Grid container direction={"row"} justifyContent={'space-evenly'} alignItems={'center'} columnSpacing={3}>
                                        <Grid item xs={6}>
                                            <Button onClick={handleConfirm} variant='contained' fullWidth>
                                                Yes
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button onClick={close} variant='contained' fullWidth>
                                                No
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog >
            </ThemeProvider>
        </div >
    );
}